import {
  EVENT_SEARCH_MODAL_CLOSING,
  EVENT_SEARCH_MODAL_LOADING,
  EVENT_SEARCH_MODAL_OPENING,
  EVENT_SEARCH_MODAL_USERINPUT,
  EVENT_SEARCH_SURPRISE_ME,
} from "../constants";

export default function listenForSearchModalEvents(
  handler: (event: Event | CustomEvent) => void,
): string[] {
  const events = [
    EVENT_SEARCH_MODAL_OPENING,
    EVENT_SEARCH_MODAL_CLOSING,
    EVENT_SEARCH_MODAL_USERINPUT,
    EVENT_SEARCH_SURPRISE_ME,
    EVENT_SEARCH_MODAL_LOADING,
  ];

  events.forEach((eventName: string) => {
    window.addEventListener(eventName, handler);
  });

  return events;
}
